import LinkCell from './LinkCell';
import LinkTagsCell from './LinkTagsCell';
import BurstFilterCell from './BurstFilterCell';
import DeleteCell from './DeleteCell';
import CopyCell from './CopyCell';
import EditCell from './EditCell';
import TextCell from './TextCell';
import PopupCell from './PopupCell';
import ToggleCell from './ToggleCell';
import RadioSelectCell from './RadioSelectCell';
import LineageCell from './LineageCell';
import SelectedCell from './SelectedCell';
import HistoryCell from './HistoryCell';
import LoginAsCell from './LoginAsCell';
import AsyncActionCell from './AsyncActionCell';
import PreCell from './PreCell';
import TranslationCell from './TranslationCell';
import FontPreviewCell from './FontPreviewCell';
import AsyncTooltipCell from './AsyncTooltipCell';
import TagCell from './TagCell';
import NodeNameCell from './NodeNameCell';
import SourceNameCell from './SourceNameCell';
import EditReportAlertRuleCell from './EditReportAlertRuleCell';
import GenerateReportAlertsCell from './GenerateReportAlertsCell';

import TestValueCell from 'app/extreport/grid/TestValueCell';
import OverlayMetricsGridDataCell from 'components/metric/collaboration-controls/overlay-metrics/OverlayMetricsGridDataCell';
import CompareLinesGridDataCell from 'components/metric/collaboration-controls/overlay-metrics/CompareLinesGridDataCell';
import KpiChartOverlayGridDataCell from 'components/report-content/components/kpi-chart/parts/overlays/KpiChartOverlayGridDataCell';
import ToggleEventCalendarCell from 'app/chart/grid/ToggleEventCalendarCell';
import UnlinkCell from 'app/ext-content/grid/UnlinkCell';
import CopyTextCell from 'components/common/grid/cell/CopyTextCell';
import CategoryNameCell from 'app/editor/category/CategoryNameCell';
import ManualRunRequestCell from 'app/editor/schedule/ManualRunRequestCell';
import PreviewCell from 'components/metric/collaboration-controls/PreviewCell';
import ErrorMessageCell from 'app/monitor/grid/ErrorMessageCell';
import Refetch from 'components/metric/last-metric-values/Refetch';
import CodeHistoryCell from 'app/editor/page/grid/CodeHistoryCell';
import ContentCell from 'app/announcement/ContentCell';
import InsightNameCell from 'app/extreport/concierge/InsightNameCell';
import LastGenerationCell from 'app/extreport/concierge/LastGenerationCell';
import RemoveKeptLinkCell from 'app/editor/glossary/RemoveKeptLinkCell';
import LlmLogCell from 'app/concierge/LlmLogCell';

export const Components: { [key: string]: any } = {
    link: LinkCell,
    linkTags: LinkTagsCell,
    burstFilter: BurstFilterCell,
    delete: DeleteCell,
    copy: CopyCell,
    edit: EditCell,
    text: TextCell,
    popup: PopupCell,
    toggle: ToggleCell,
    radioSelect: RadioSelectCell,
    lineage: LineageCell,
    selected: SelectedCell,
    history: HistoryCell,
    codeHistory: CodeHistoryCell,
    loginAs: LoginAsCell,
    asyncAction: AsyncActionCell,
    preCell: PreCell,
    translationCell: TranslationCell,
    fontPreviewCell: FontPreviewCell,
    overlayMetricsGridData: OverlayMetricsGridDataCell,
    compareLinesGridData: CompareLinesGridDataCell,
    kpiChartOverlayGridData: KpiChartOverlayGridDataCell,
    asyncTooltipCell: AsyncTooltipCell,
    testValueCell: TestValueCell,
    toggleEventCalendar: ToggleEventCalendarCell,
    tag: TagCell,
    graphNodeName: NodeNameCell,
    sourceName: SourceNameCell,
    unlink: UnlinkCell,
    copyText: CopyTextCell,
    categoryName: CategoryNameCell,
    manualRunRequestCell: ManualRunRequestCell,
    overlayPreview: PreviewCell,
    refetchData: Refetch,
    errorMessageCell: ErrorMessageCell,
    contentCell: ContentCell,
    editReportAlertRule: EditReportAlertRuleCell,
    generateReportAlerts: GenerateReportAlertsCell,
    insightName: InsightNameCell,
    removeKeptLink: RemoveKeptLinkCell,
    lastGeneration: LastGenerationCell,
    llmLog: LlmLogCell,
};
